import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import { AnimationWrapper } from '../AnimationWrapper'
import styles from './Label.module.scss'

export const Label: FunctionComponent<LabelProps> = ({
  children,
  className,
  htmlFor,
  labelText,
  withAnimation = false,
  ...rest
}) => (
  <label
    className={classnames(styles.label, className)}
    htmlFor={htmlFor}
    {...rest}
  >
    {withAnimation ? (
      <AnimationWrapper inverted={true}>{labelText}</AnimationWrapper>
    ) : (
      labelText
    )}
    {children}
  </label>
)

///////// IMPLEMENTATION /////////

type LabelProps = {
  className?: string
  htmlFor?: string
  labelText: string
  withAnimation?: boolean
  children?: ReactNode
} & HTMLProps<HTMLLabelElement>
